export class UploadImageDto {
  file!: File;

  constructor() {
    const formData = new FormData();
    formData.append('file', this.file);
  }
}
